import React, { Component } from "react";
import { connect } from "react-redux";
import { setFilter } from "Actions";
import { fetchMed } from "Thunks";
import FilterComponent from "./FilterComponent";

export class Filter extends Component {
  render() {
    return <FilterComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({
  filter: state.filter.filterState
});

const mapDispatchToProps = dispatch => ({
  setFilter: filter => dispatch(setFilter(filter)),
  fetchMedias: params => dispatch(fetchMed(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// ./src/components/Common/Filter/index.js